(function () {
	let swiperMulticolumn;
	const multicolumnSwipeEnabled = document.querySelector(
		".swiper--multicolumn",
	);

	const initSlider = (() => {
		multicolumnSwipeEnabled.classList.add('multicolumn-swiper-wrapper');
		const slides = document.querySelectorAll('.multicolumn-list__item');

		slides.forEach(slide => {
			slide.classList.add('swiper-slide');
		});

		swiperMulticolumn = new Swiper('.swiper--multicolumn', {
			loop: false,
			slidesPerView: 1,
			navigation: {
				nextEl: '.multicolumn-button-next',
				prevEl: '.multicolumn-button-prev',
			},

		});

	});

	const destroySlider = () => {
		multicolumnSwipeEnabled.classList.remove('multicolumn-swiper-wrapper');
		const slides = document.querySelectorAll('.multicolumn-list__item');

		swiperMulticolumn.destroy(true, true);
		swiperMulticolumn = undefined;

		slides.forEach(slide => {
			slide.removeAttribute('style');
			slide.classList.remove('swiper-slide')
		});
	}

	const initMulticolumn = () => {
		const multicolumnSection = document.querySelector('.multicolumn-section');

		const sectionResizeObserver = new ResizeObserver((entries) => {

			const [entry] = entries;

			if (entry.contentRect.width < 990 && multicolumnSwipeEnabled) {
				initSlider();
			} else if (swiperMulticolumn) {
				destroySlider();
			}
		});

		sectionResizeObserver.observe(multicolumnSection);
	}

	// Add smooth scrolling for anchor links
	const initSmoothScrolling = () => {
		const multicolumnLinks = document.querySelectorAll('.multicolumn-section a[href^="#"]');
		
		multicolumnLinks.forEach(link => {
			link.addEventListener('click', function(e) {
				const href = this.getAttribute('href');
				
				// Check if it's an anchor link (starts with #)
				if (href && href.startsWith('#') && href.length > 1) {
					const targetId = href.substring(1);
					const targetElement = document.getElementById(targetId);
					
					if (targetElement) {
						e.preventDefault();
						targetElement.scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						});
						
						// Update URL hash without jumping
						if (history.pushState) {
							history.pushState(null, null, href);
						}
					}
				}
			});
		});
	};

	if (swiperMulticolumn) {
		destroySlider();
	}
	initMulticolumn();
	initSmoothScrolling();
	
	document.addEventListener('shopify:section:load', function () {
		if (swiperMulticolumn) {
			destroySlider();
		}
		initMulticolumn();
		initSmoothScrolling();
	});

})();